import React from "react";

const themes = {
  pending: {
    bar: "#0d9f6e",
    border: "#d0d5dd",
    bg: "#ffffff",
    iconColor: "#0d9f6e",
    title: "#101828",
    label: "Angebot gesendet",
    icon: "i",
  },
  accepted: {
    bar: "#0d9f6e",
    border: "#a6f4c5",
    bg: "#ecfdf3",
    iconColor: "#12b76a",
    title: "#101828",
    label: "Angebot angenommen",
    icon: "✓",
  },
  rejected: {
    bar: "#0d9f6e",
    border: "#fecdca",
    bg: "#fef3f2",
    iconColor: "#f04438",
    title: "#101828",
    label: "Angebot abgelehnt",
    icon: "✕",
  },
};

export default function OfferMessageCard({ data }) {
  if (!data) return null;

  const status = data.status || "pending";
  const theme = themes[status] || themes.pending;

  // pending: تفاصيل أكتر | accepted/rejected: السعر فقط زي الصور
  let detailLine = "";
  if (status === "pending") {
    detailLine = [
      data.price ? `${data.price} ${data.currency || "EUR"}` : null,
      data.payment_term ? `Zahlungsziel: ${data.payment_term}` : null,
      data.valid_until ? `gültig bis ${data.valid_until}` : null,
    ]
      .filter(Boolean)
      .join(", ");
  } else {
    detailLine = data.price
      ? `${data.price} ${data.currency || "EUR"}`
      : "";
  }

  return (
    <div className="offer-card-root" style={{ maxWidth: 420, width: "100%" }}>
      {/* شريط المسار */}
      <div
        style={{
          background: theme.bar,
          color: "#fff",
          borderRadius: 10,
          padding: "10px 14px",
          display: "flex",
          alignItems: "center",
          gap: 10,
          fontWeight: 600,
          fontSize: 14,
        }}
      >
        <span>📦</span>
        <span
          style={{
            flex: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {data.from || "—"}
        </span>
        <span>→</span>
        <span
          style={{
            flex: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            textAlign: "right",
          }}
        >
          {data.to || "—"}
        </span>
      </div>

      {/* صندوق الحالة */}
      <div
        style={{
          marginTop: 10,
          border: `1px dashed ${theme.border}`,
          background: theme.bg,
          borderRadius: 10,
          padding: "12px 14px",
          display: "flex",
          gap: 12,
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: "50%",
            border: `2px solid ${theme.iconColor}`,
            color: theme.iconColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: status === "pending" ? 12 : 16,
            fontWeight: 700,
            flexShrink: 0,
          }}
        >
          {theme.icon}
        </div>
        <div style={{ color: theme.title, fontSize: 14, lineHeight: 1.4 }}>
          <span>
            {theme.label}:{" "}
            <strong>{detailLine}</strong>
          </span>
        </div>
      </div>
    </div>
  );
}